import { useState, useCallback, useEffect } from 'react';
import useGameHistory from './useGameHistory';

const STORAGE_KEY = 'biblika_max_points';

export function loadMaxPoints() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch { return {}; }
}

function saveMaxPoints(gameId, pts) {
  const stored = loadMaxPoints();
  if (pts > (stored[gameId] || 0)) {
    stored[gameId] = pts;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  }
}

export function getGlobalStats() {
  const stored = loadMaxPoints();
  const games = Object.keys(stored);
  if (games.length === 0) return { average: 0, games: 0 };
  const total = games.reduce((sum, g) => sum + stored[g], 0);
  return { average: Math.round(total / games.length), games: games.length };
}

export default function useStreakPoints(gameId) {
  const [points, setPoints] = useState(0);
  const [streak, setStreak] = useState(0);
  const { record } = useGameHistory(gameId);

  useEffect(() => {
    if (gameId && points > 0) {
      saveMaxPoints(gameId, points);
    }
  }, [gameId, points]);

  const onCorrect = useCallback(() => {
    record(true);
    setStreak((s) => {
      const next = s + 1;
      const bonus = Math.min(next, 5);
      setPoints((p) => p + bonus);
      return next;
    });
  }, [record]);

  const onWrong = useCallback(() => {
    record(false);
    setStreak(0);
    setPoints((p) => Math.max(0, p - 1));
  }, [record]);

  return { points, streak, onCorrect, onWrong };
}
